<template>
  <div>
    <b-form>
      <div v-if="panduanKewajiban" class="mb-2">
        <button type="button" class="btn btn-warning text-white" @click="$bvModal.show(`modal-indentify${page}`)">
          <i class="fa fa-question-circle" />
          Panduan
        </button>
      </div>
      <span style="font-weight: 600">{{ formTitle }}</span>
      <div class="row mb-3">
        <div :class="['col-md-12 mt-3', { 'pe-none': is_selesai }]">
          <label>Status kewajiban yang telah dilakukan <span class="text-danger">*</span></label>
          <div style="width: 200px">
            <v-select
              v-model="form.status_kewajiban"
              id="status_kewajiban"
              :reduce="(data) => data.value"
              label="text"
              :options="optionStatus"
              name="Status"
              v-validate="'required'"
              :class="{
                input: true,
                'is-danger': errors.has('Status'),
              }"
            />
          </div>
          <span class="text-danger" v-if="errors.has('Status')">
            {{ errors.first('Status') }}
          </span>
        </div>

        <div v-if="form.status_kewajiban === 'Sudah'" :class="['row', { 'pe-none': is_selesai }]">
          <div class="col-md-12 mt-3">
            <label>Bentuk Perizinan {{ jenis_kegiatan }} <span class="text-danger">*</span></label>
            <b-form-input
              v-model="form.bentuk_perizinan"
              id="bentuk_perizinan"
              v-validate="'required'"
              name="Bentuk Perizinan"
              :class="{
                input: true,
                'is-danger': errors.has('Bentuk Perizinan'),
              }"
            ></b-form-input>
            <span class="text-danger" v-if="errors.has('Bentuk Perizinan')">
              {{ errors.first('Bentuk Perizinan') }}
            </span>
          </div>
          <div class="col-md-12 mt-3">
            <div class="row">
              <div class="col-6">
                <label>
                  Lokasi yang diberikan pada Perizinan {{ jenis_kegiatan }}
                  <span class="text-danger">*</span>
                </label>
                <b-form-input
                  v-model="form.lokasi"
                  id="lokasi_perizinan"
                  v-validate="'required'"
                  name="Lokasi"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Lokasi'),
                  }"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Lokasi')">
                  {{ errors.first('Lokasi') }}
                </span>
              </div>
              <div class="col-3">
                <label>luas <span class="text-danger">*</span></label>
                <div class="input-units">
                  <b-form-input
                    v-model="form.luas"
                    id="luas_perizinan"
                    v-mask="decimalMask(form.luas)"
                    v-validate="'required'"
                    name="Luas"
                    :class="{
                      input: true,
                      'is-danger': errors.has('Luas'),
                    }"
                  ></b-form-input>
                  <div class="text-units">
                    <span>{{ form.luas }}</span>
                    <span> ha</span>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.has('Luas')">
                  {{ errors.first('Luas') }}
                </span>
              </div>
              <div class="col-3">
                <label>panjang <span class="text-danger">*</span></label>
                <div class="input-units">
                  <b-form-input
                    v-model="form.panjang"
                    id="panjang_perizinan"
                    v-mask="decimalMask(form.panjang)"
                    v-validate="'required'"
                    name="Panjang"
                    :class="{
                      input: true,
                      'is-danger': errors.has('Panjang'),
                    }"
                  ></b-form-input>
                  <div class="text-units">
                    <span>{{ form.panjang }}</span>
                    <span> km</span>
                  </div>
                </div>
                <span class="text-danger" v-if="errors.has('Panjang')">
                  {{ errors.first('Panjang') }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <div class="row">
              <div class="col-6">
                <label>Waktu Penerbitan Perizinan {{ jenis_kegiatan }} <span class="text-danger">*</span></label>
                <DatePicker
                  lang="en"
                  id="waktu_perizinan"
                  :placeholder="waktu_penerbitan"
                  input-class="form-control"
                  @change="
                    (val) => {
                      this.waktu_penerbitan = val.toLocaleDateString('en-GB')
                      this.form.waktu_penerbitan = formatDate(val, 'YYYY-MM-DD')
                      this.errors.remove('Waktu Penerbitan')
                    }
                  "
                  class="w-100"
                >
                  <i class="fa fa-calendar-o" slot="calendar-icon" />
                </DatePicker>
                <span class="text-danger" v-if="errors.has('Waktu Penerbitan')">
                  {{ errors.first('Waktu Penerbitan') }}
                </span>
              </div>
              <div class="col-6">
                <label>Masa Berlaku Perizinan {{ jenis_kegiatan }} <span class="text-danger">*</span></label>
                <b-form-input
                  v-model="form.masa_berlaku"
                  id="masa_berlaku"
                  v-validate="'required'"
                  name="Masa Berlaku"
                ></b-form-input>
                <span class="text-danger" v-if="errors.has('Masa Berlaku')">
                  {{ errors.first('Masa Berlaku') }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-else :class="['col-12', { 'pe-none': is_selesai }]">
          <div class="mt-3">
            <label>Keterangan (Alasan belum dilaksanakan)</label>
            <ckeditor
              id="keterangan_alasan"
              :editor="wygEditor"
              v-model="form.keterangan_alasan"
              name="Keterangan Alasan"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Keterangan Alasan')">
              {{ errors.first('Keterangan Alasan') }}
            </span>
          </div>
          <div class="mt-3">
            <label> Rencana Tindak Lanjut (Penjelasan kapan bagaimana rencana akan dilaksanakan) </label>
            <ckeditor
              id="rencana_tindak_lanjut"
              :editor="wygEditor"
              v-model="form.rencana_tindak_lanjut"
              name="Rencana Tindak Lanjut"
            ></ckeditor>
            <span class="text-danger" v-if="errors.has('Rencana Tindak Lanjut')">
              {{ errors.first('Rencana Tindak Lanjut') }}
            </span>
          </div>
        </div>

        <div class="col-md-6 mt-3">
          <label>Upload Dokumentasi</label>
          <div class="row">
            <div>
              <small>Format file: PDF</small>
            </div>
            <div class="col-6">
              <b-form-file
                v-model="form.dokumentasi"
                id="dokumentasi_perizinan"
                plain
                class="form-control"
                name="Dokumentasi"
                accept=".pdf"
                :disabled="is_selesai"
              ></b-form-file>
            </div>
            <div class="col-6 d-flex">
              <a
                v-if="!is_selesai"
                :class="['btn btn-primary mr-2 text-white', { disabled: form.dokumentasi === null }]"
                @click="uploadFile"
              >
                <i class="fa fa-cloud-upload" />
                Unggah
              </a>
              <a
                :class="{
                  'btn btn-success': true,
                  disabled: !id_file_bukti_dukung,
                }"
                @click="unduhFile(id_file_bukti_dukung)"
              >
                <i class="fa fa-download" />
                Unduh
              </a>
            </div>
          </div>
          <span class="text-danger" v-if="errors.has('Dokumentasi')">
            {{ errors.first('Dokumentasi') }}
          </span>
          <span class="text-danger" v-if="errors.has('dokumentasi', 'custom')">
            {{ errors.first('dokumentasi', 'custom') }}
          </span>
        </div>
      </div>

      <div :class="[{ 'pe-none': is_selesai }]">
        <label>Keterangan Lainnya</label>
        <ckeditor @ready="onEditorReady" :editor="wygEditor" v-model="form.keterangan_lainnya"></ckeditor>
      </div>

      <div class="mt-3 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
    </b-form>

    <b-modal :id="`modal-indentify${page}`" :title="`Panduan`" size="md" body-bg-variant="white">
      <template>
        <div>
          {{ panduanKewajiban }}
        </div>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" size="sm" class="float-right" @click="$bvModal.hide(`modal-indentify${page}`)">
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../../helper/helpernew'
import { decimalMask } from '../../../helper/validationHelper'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  props: ['formTitle', 'page', 'panduanKewajiban'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      form: {
        status_kewajiban: 'Sudah',
        bentuk_perizinan: '',
        lokasi: '',
        luas: '0',
        panjang: '0',
        waktu_penerbitan: null,
        masa_berlaku: '',
        keterangan_alasan: '',
        rencana_tindak_lanjut: '',
        dokumentasi: null,
        keterangan_lainnya: '',
      },
      is_selesai: false,
      id_file_bukti_dukung: null,
      waktu_penerbitan: 'dd/mm/yyyy',
      optionStatus: [
        { value: 'Sudah', text: 'Sudah' },
        { value: 'Belum', text: 'Belum' },
      ],
      wygEditor: ClassicEditor,
      jenis_kegiatan: null,
    }
  },
  methods: {
    formatDate,
    decimalMask,

    uploadFile() {
      this.$loading(true)
      const formData = new FormData()
      formData.append('file_bukti_dukung_12', this.form.dokumentasi)

      axios
        .post(this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then(async (res) => {
          this.$toasted.success('Berhasil Diunggah')
          this.id_file_bukti_dukung = res.data.data[`id_file_bukti_dukung_${this.page}`]
          this.form.dokumentasi = null
        })
        .catch((err) => {
          this.$toasted.danger('Gagal Diunggah')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async nextForm() {
      if (this.is_selesai) {
        return true
      }

      this.errors.clear()
      if (this.form.status_kewajiban === 'Sudah' && this.form.waktu_penerbitan === null) {
        this.addFormError('Waktu Penerbitan')
      }

      if ((await this.$validator.validateAll()) && !this.errors.any()) {
        this.$loading(true)
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append('status_kewajiban_12', this.form.status_kewajiban)
          if (this.form.status_kewajiban === 'Sudah') {
            formData.append('bentuk_perizinan_berusaha_12', this.form.bentuk_perizinan)
            formData.append('lokasi_yang_diberikan_12', this.form.lokasi)
            formData.append('luas_12', parseFloat(this.form.luas))
            formData.append('panjang_12', parseFloat(this.form.panjang))
            formData.append('waktu_penerbitan_12', this.form.waktu_penerbitan)
            formData.append('masa_berlaku_izin_12', this.form.masa_berlaku)
          } else {
            formData.append('alasan_belum_dilaksanakan_12', this.form.keterangan_alasan)
            formData.append('rencana_tindak_lanjut_12', this.form.rencana_tindak_lanjut)
          }
          formData.append('keterangan_lainnya_12', this.form.keterangan_lainnya)
        }

        return axios
          .post(this.baseapiPengendalian + `api/laporan_tahunan/${this.$route.query.id_laporan}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ` + this.user.accessToken,
            },
          })
          .then((res) => {
            return true
          })
          .catch((err) => {
            Swal.fire('Gagal', 'Terjadi kesalahan', 'error')
            return false
          })
          .finally(() => {
            this.$loading(false)
          })
      } else {
        return false
      }
    },

    addFormError(fieldName) {
      this.errors.add({
        field: fieldName,
        msg: `The ${fieldName} field is required`,
      })
    },

    onEditorReady() {
      this.loadLaporanTahunan()
    },

    loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      axios
        .get(`${this.baseapiPengendalian}api/laporan_tahunan/${this.$route.query.id_laporan}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((res) => {
          const data = res.data.data
          this.jenis_kegiatan = data.jenis_kegiatan
          this.is_selesai =
            data.status_laporan !== null &&
            data.status_laporan !== 'Draft' &&
            data.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'

          this.form.status_kewajiban = data[`status_kewajiban_12`] || 'Sudah'
          if (this.form.status_kewajiban === 'Sudah') {
            this.form = {
              ...this.form,
              bentuk_perizinan: data[`bentuk_perizinan_berusaha_12`] || '',
              lokasi: data[`lokasi_yang_diberikan_12`] || '',
              luas: String(data[`luas_12`]) || '0',
              panjang: String(data[`panjang_12`]) || '0',
              waktu_penerbitan: data[`waktu_penerbitan_12`] || null,
              masa_berlaku: data[`masa_berlaku_izin_12`] || '',
              dokumentasi: null,
              keterangan_lainnya: data[`keterangan_lainnya_12`] || '',
            }
          } else {
            this.form = {
              ...this.form,
              keterangan_alasan: data[`alasan_belum_dilaksanakan_12`] || '',
              rencana_tindak_lanjut: data[`rencana_tindak_lanjut_12`] || '',
              dokumentasi: null,
              keterangan_lainnya: data[`keterangan_lainnya_12`] || '',
            }
          }
          this.id_file_bukti_dukung = data[`id_file_bukti_dukung_12`]
          // prettier-ignore
          this.waktu_penerbitan = data[`waktu_penerbitan_12`]
            ? formatDate(data[`waktu_penerbitan_12`], 'DD/MM/YYYY')
            : 'dd/mm/yyyy'
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async unduhFile(id) {
      const res = await axios.get(
        `${this.baseapiPengendalian}api/files/download/${id}`,
        this.getApiOption({ responseType: 'blob' }),
      )
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },

    getApiOption(option = {}) {
      return {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken,
        },
        ...option,
      }
    },
  },
}
</script>
